module.exports = __webpack_public_path__ + "img/mnj.6231895a.png";